module.exports = __webpack_public_path__ + "img/img_sky_all_200.4f9f91f8.png";